/** Transformers **/
const booleanTransformer = () => {
    return (potentialBoolean) => toBoolean(potentialBoolean)
};
const defaultListTransformer = () => {
    return (list) => { return !isUndefinedOrNull(list) ? list : [] }
};
const defaultTransformer = (clazz) =>{
    return (source) => {
        return source instanceof clazz ? source: new clazz(source);
    }
};
const dayOfWeekTransformer = () => {
    return (stringValue) => {
        let enumValue = DayOfWeek[stringValue?.toUpperCase()];
        if (!isUndefinedOrNull(enumValue)) {
            return enumValue;
        }

        ontech.log.warn('dayOfWeekTransformer received invalid value for Day of Week', stringValue);
        return null;
    }
};
const identityTransformer = () => {
    return (value) => value;
};
const timeTransformer = () => {
    return (time) => to24Hour(time);
};
const supplierTransformer = (supplier) => {
    return (value) => supplier(value);
}

/** Class helpers **/
function convertToJSON(removeNull = true) {
    const skipFields = [
        '_isEmpty',
        '_name',
        '_parent',
        'aliases',
        'errors',
        'keys',
        'requiredFields'
    ];

    let jsonObject = {};

    // Make sure the aliases object is present
    this.aliases = this.aliases || {};

    // build json Object
    for(const key in this){
        // Field to Skip?
        if(skipFields.includes(key)){
            continue;
        }

        let keyToUse = this.aliases[key] || key;

        let valueToSet = getJsonObject(this[key]);
        if(Array.isArray(valueToSet)){
            jsonObject[keyToUse] = [];
            for(let element of valueToSet){
                let value = getJsonObject(element);
                if(!isUndefinedOrNull(value)) {
                    jsonObject[keyToUse].push(value);
                }
            }
        }
        else {
            if(!removeNull || (removeNull && !isUndefinedOrNull(valueToSet))) {
                jsonObject[keyToUse] = valueToSet;
            }
        }
    }

    return whatToReturn(removeNull, jsonObject);
}
const getJsonObject = (objToConvert) => {
    if(
        !isUndefinedOrNull(objToConvert)
        && !isUndefinedOrNull(objToConvert.toJson)
        && (typeof objToConvert.toJson === 'function')
    ){
        return  objToConvert.toJson();
    }

    return objToConvert;
};
const initField = (obj, key, source, defaultValue, transformer, processor, alias) => {
    if(defaultValue === undefined){
        defaultValue = null;
    }

    if(isUndefinedOrNull(alias)){
        alias = key;
    }
    else{
        // Store Aliases in object
        if(isUndefinedOrNull(obj['aliases'])){
            obj['aliases'] = {}
        }
        obj['aliases'][key] = alias;
    }

    if(isEmpty(source)){
        obj[key] = defaultValue;
    }
    else{
        if(isUndefinedOrNull(processor)){
            obj[key] = transform(transformer, source, alias, key, defaultValue);
        }
        else{
            // Source is a list and we need to process each element
            obj[key] = selfOrDefault(defaultValue, []);
            let listToUse = selfOrDefault(source[alias], source[key]);
            if(!isUndefinedOrNull(listToUse)){
                for(const value of listToUse){
                    let returnValue = processElement(processor, value);
                    if(!isUndefinedOrNull(returnValue)) {
                        obj[key].push(returnValue);
                    }
                }
            }
        }
    }
};
function isModelEmpty(){
    let objectIsEmpty = true;
    for(const key of this.keys){
        if(!isEmpty(this[key])){
            objectIsEmpty = false;
            break;
        }
    }

    return objectIsEmpty;
}
const processElement = (processor, value) => {
    let returnValue = processor(value);
    if(
        !isUndefinedOrNull(returnValue)
        && (
            typeof returnValue !== 'object'
            || (
                typeof returnValue === 'object'
                && (
                    isUndefinedOrNull(returnValue.isValid)
                    || returnValue.isValid()
                )
            )
        )
    ) {
        return returnValue;
    }

    return null;
}
const transform = (transformer, source, alias, key, defaultValue) => {
    let valueToUse;
    if (!isUndefinedOrNull(transformer) && isFunction(transformer)) {
        // Get Alias or Key if Alias is missing
        valueToUse = selfOrDefault(source[alias], source[key]);
        valueToUse = transformer(valueToUse);
    } else {
        if (!isUndefinedOrNull(source[alias])) {
            valueToUse = source[alias];
        } else if (!isUndefinedOrNull(source[key])) {
            valueToUse = source[key];
        }

        valueToUse = selfOrDefault(valueToUse, defaultValue);
    }

    return valueToUse;
};
const whatToReturn = (removeNull, jsonObject) => {
    if (removeNull && !Array.isArray(jsonObject)) {
        return !isEmpty(jsonObject) ? jsonObject : null
    } else {
        return jsonObject;
    }
};

class OrderEditInfo {
    constructor(info) {
        initField(this, 'isDropShipOrder', info, false);
        initField(this, 'installationDate', info);
        initField(this, 'orderNumber', info);
        initField(this, 'subtotalPrice', info);
    }
}